
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class OrderProductBillingItemsTaxGrid extends Serenity.EntityGrid<OrderProductBillingItemsTaxRow, any> {
        protected getColumnsKey() { return OrderProductBillingItemsTaxColumns.columnsKey; }
        protected getDialogType() { return OrderProductBillingItemsTaxDialog; }
        protected getIdProperty() { return OrderProductBillingItemsTaxRow.idProperty; }
        protected getInsertPermission() { return OrderProductBillingItemsTaxRow.insertPermission; }
        protected getLocalTextPrefix() { return OrderProductBillingItemsTaxRow.localTextPrefix; }
        protected getService() { return OrderProductBillingItemsTaxService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}